<p-menu #options [model]="menuItems" [popup]="true" [appendTo]="'body'"></p-menu>
<button
  type="button"
  pButton
  pRipple
  (click)="options.toggle($event)"
  pTooltip="Export Timeline"
  tooltipPosition="bottom"
  class="p-button-text p-button-plain p-button-lg tool-bar-pbutton icon-top-space-toolbar icon-right-space-toolbar icon-left-space-toolbar">
  <span class="material-symbols-outlined"> download </span>
</button>
